<template>
    <b-row v-if="row.msgshort !== ''">
        <a  @click="showDialog">{{row.msgshort}}</a>
    </b-row>
    <b-row v-else>
    </b-row>
</template>

<script>

export default {
    data() {
        return {
        }
    },
    props: ['row'],
    
    components: {
    },

    methods: {
        showDialog() {
            this.$parent.$parent.showFullMessage(this.row);
        }
    }
}

</script>